import { render, staticRenderFns } from "./ShippingDetailsPage.vue?vue&type=template&id=66e19319&"
import script from "./ShippingDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ShippingDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports